import { eConsumerTypes } from './eConsumerTypes';

export enum eCreateSigningAppointmentFormDataOwnerTypes {
  seller = 'seller',
  sellerEmail = 'sellerEmail',
  borrower = 'borrower',
  borrowerEmail = 'borrowerEmail',
}

const digitalSchedulingOwnerTypes = new Set<unknown>([
  eCreateSigningAppointmentFormDataOwnerTypes.borrowerEmail,
  eCreateSigningAppointmentFormDataOwnerTypes.sellerEmail,
]);

export const isDigitalSchedulingOwnerType = (value: unknown): boolean => {
  return digitalSchedulingOwnerTypes.has(value);
};

const ownerTypeDictionary: Record<eCreateSigningAppointmentFormDataOwnerTypes, eConsumerTypes> = {
  [eCreateSigningAppointmentFormDataOwnerTypes.seller]: eConsumerTypes.seller,
  [eCreateSigningAppointmentFormDataOwnerTypes.sellerEmail]: eConsumerTypes.seller,
  [eCreateSigningAppointmentFormDataOwnerTypes.borrower]: eConsumerTypes.borrower,
  [eCreateSigningAppointmentFormDataOwnerTypes.borrowerEmail]: eConsumerTypes.borrower,
};

const formDataOwnerTypeDict: Record<eConsumerTypes, eCreateSigningAppointmentFormDataOwnerTypes> = {
  [eConsumerTypes.seller]: eCreateSigningAppointmentFormDataOwnerTypes.seller,
  [eConsumerTypes.borrower]: eCreateSigningAppointmentFormDataOwnerTypes.borrower,
};

const formDataOwnerTypeWithEmailDict: Record<eConsumerTypes, eCreateSigningAppointmentFormDataOwnerTypes> = {
  [eConsumerTypes.seller]: eCreateSigningAppointmentFormDataOwnerTypes.sellerEmail,
  [eConsumerTypes.borrower]: eCreateSigningAppointmentFormDataOwnerTypes.borrowerEmail,
};

export const getConsumerTypeFromFormDataOwnerType = (ownerType: eCreateSigningAppointmentFormDataOwnerTypes) => {
  return ownerTypeDictionary[ownerType];
};

export const getFormDataOwnerType = (
  ownerType: eConsumerTypes,
  isDigitalScheduling?: boolean
): eCreateSigningAppointmentFormDataOwnerTypes => {
  if (!isDigitalScheduling) {
    return formDataOwnerTypeDict[ownerType];
  }
  return formDataOwnerTypeWithEmailDict[ownerType];
};
